/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import { exportElement as a } from "./export-element.mjs";
function m(t) {
  return (r, o = {}, n) => u(t, r, o, n);
}
function u(t, r, o = {}, n) {
  let e;
  i();
  function i() {
    t(l(), o, d);
  }
  function d() {
    document.body.removeChild(e), e = void 0, n && n();
  }
  function l() {
    e = document.createElement("div"), e.className = "k-treelist-pdf-export-element";
    const p = a(r);
    return e.appendChild(p), document.body.appendChild(e), e;
  }
}
export {
  m as provideSaveTreeListPDF
};
